<template>
	<Transition name="smart-app-banner">
		<div v-if="isVisible" class="smart-app-banner" role="dialog" :aria-label="$t('components.smart_app_banner.title')">
			<button type="button" class="smart-app-banner__close" :aria-label="$t('components.smart_app_banner.close')" @click="dismiss">
				<GlobalIcon name="close" :height="14" :width="14" />
			</button>
			<GlobalLogo class="smart-app-banner__logo" />
			<div class="smart-app-banner__text">
				<p class="smart-app-banner__title">
					{{ $t('components.smart_app_banner.title') }}
				</p>
				<p class="smart-app-banner__subtitle">
					{{ $t('components.smart_app_banner.offer_prefix') }}
					<span class="smart-app-banner__highlight">{{ $t('components.smart_app_banner.amount') }}</span>
					{{ $t('components.smart_app_banner.offer_suffix') }}
					<span class="smart-app-banner__highlight">{{ $t('components.smart_app_banner.code') }}</span>
				</p>
			</div>
			<a class="smart-app-banner__cta" :href="storeLink" target="_blank" rel="nofollow noopener" @click="dismiss">
				{{ $t('components.smart_app_banner.cta') }}
			</a>
		</div>
	</Transition>
</template>

<script setup lang="ts">
const STORAGE_KEY = 'cf_smart_app_banner_closed_at'
const HIDE_FOR_MS = 24 * 60 * 60 * 1000

const { storeLink } = useStoreLink()
const isVisible = ref(false)

// Lets fixed-position elements (call button, Cookiebot widget) move up while the banner is open
useHead({ htmlAttrs: { class: computed(() => (isVisible.value ? 'smart-app-banner-open' : undefined)) } })

// Client-only: the page is served from a shared ISR/CDN cache, so visibility must not be decided during SSR.
onMounted(() => {
	try {
		const closedAt = Number(localStorage.getItem(STORAGE_KEY))
		isVisible.value = !closedAt || Date.now() - closedAt >= HIDE_FOR_MS
	} catch {
		isVisible.value = true
	}
})

const dismiss = () => {
	isVisible.value = false
	try {
		localStorage.setItem(STORAGE_KEY, Date.now().toString())
	} catch {}
}
</script>

<style lang="scss" scoped src="./SmartAppBanner.scss"></style>

<style lang="scss">
// Banner is mobile-only (hidden from 768px), so the offset applies only below that
@media (max-width: 767px) {
	html.smart-app-banner-open {
		.call-button,
		#CookiebotWidget {
			bottom: 80px !important;
		}
	}
}
</style>
